(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canada-banner"] && !Shopify.designMode) return;
  try {
    
  const productsTabBtns = document.querySelectorAll('.rich-text__product-tabs button');
  productsTabBtns.forEach((productsTabBtn) => {
    productsTabBtn.addEventListener('click', function() {
      const siblings = this.closest('.rich-text__product-tabs--wrapper').querySelectorAll('button');
      siblings.forEach((btn) => {
        btn.classList.remove('active')
      });
      this.classList.add('active');

      const pannels = this.closest('.rich-text__product-tabs').querySelectorAll('.rich-text__product-tab');
      pannels.forEach((panel) => {
        panel.classList.add('hidden');
      });
      const id = this.dataset.id;
      const focusPannel = document.getElementById(id);
      if(focusPannel) focusPannel.classList.remove('hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  // Toggle on a real <button> so the panels are reachable by keyboard and
  // announced to screen readers. The previous implementation put the click
  // handler on a bare <h3>, which meant the answers could only be opened with
  // a mouse (WCAG 2.1.1, Level A).
  document.querySelectorAll('.faq-accordion__question').forEach((question) => {
    question.addEventListener('click', function () {
      var isOpen = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      var panel = document.getElementById(this.getAttribute('aria-controls'));
      if (panel) panel.hidden = isOpen;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog-v2"] && !Shopify.designMode) return;
  try {
    
  const featuredBlogV2Container = document.querySelector('[data-blog-posts]');
  if(featuredBlogV2Container) {
    function initLoadMoreArticles() {
      const btn = document.querySelector('[data-load-more]');
      if(btn) {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          getPosts(event.target.href)
        });
      }
    }
    function getPosts(url) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const blogPosts = html.querySelector('[data-blog-posts] .blog__posts--list');
          const blogActions = html.querySelector('[data-actions]');
          featuredBlogV2Container.querySelector('.blog__posts--list').innerHTML = featuredBlogV2Container.querySelector('.blog__posts--list').innerHTML + blogPosts.innerHTML;

          const viewAll = `<a href='${featuredBlogV2Container.dataset.originUrl}' class='blog__button'>View all ></a>`;
          featuredBlogV2Container.querySelector('[data-actions]').innerHTML = blogActions.innerHTML + viewAll;
          initLoadMoreArticles();
        })
    }

    const featuredBlogV2Url = featuredBlogV2Container.dataset.url;
    if(featuredBlogV2Url) {
      getPosts(featuredBlogV2Url);
    }
  }  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
window.changeMenuImage = function(imgSrc, imgId) {
  const img = document.getElementById(imgId);
  if (!img) return;

  if (!imgSrc) return;

  img.src = imgSrc;
};
class StickyHeader extends HTMLElement {
    constructor() {
        super();
        this.hoverTimeout = null;
        this.agingGrandparent = null;
        document.querySelectorAll('.header__inline-menu details').forEach((details) => {
            details.addEventListener('mouseenter',(event) => {
                if(this.agingGrandparent && typeof this.agingGrandparent != 'undefined') {
                    this.agingGrandparent.removeAttribute('open');
                    this.agingGrandparent.querySelector('summary').setAttribute('aria-expanded', false);
                }
                window.clearTimeout(this.hoverTimeout);
                let $grandparent = event.target;
                $grandparent.setAttribute('open', '');
                $grandparent.querySelector('summary').setAttribute('aria-expanded', true);
            });
            details.addEventListener('mouseleave',(event) => {
                this.agingGrandparent = event.target;
                this.hoverTimeout = window.setTimeout(() => {
                    this.agingGrandparent.removeAttribute('open');
                    this.agingGrandparent.querySelector('summary').setAttribute('aria-expanded', false);
                },250);
            });
        })
        document.querySelectorAll('.header__inline-menu summary').forEach((summary) => {
            // Keyboard support: Enter/Space toggles the submenu disclosure instead of
            // navigating away. preventDefault() suppresses the synthesized click, so the
            // data-url navigation below never runs for keyboard users. The category page
            // itself stays reachable via the "Shop All" link inside the submenu.
            summary.addEventListener('keydown',(event) => {
                if(event.key !== 'Enter' && event.key !== ' ') return;
                event.preventDefault();
                const details = summary.closest('details');
                if(details.hasAttribute('open')) {
                    details.removeAttribute('open');
                    summary.setAttribute('aria-expanded', false);
                } else {
                    details.setAttribute('open', '');
                    summary.setAttribute('aria-expanded', true);
                }
            });
            summary.addEventListener('click',(event) => {
                // Synthesized clicks (keyboard / assistive tech) have detail === 0 —
                // let those toggle the disclosure rather than navigate.
                if(event.detail === 0) return;
                if(summary.dataset.url) {
                  window.location.href = summary.dataset.url;
                }
            });
        })
    }

    connectedCallback() {
        this.header = document.getElementById('shopify-section-header');
        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
    }

    disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);

                requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            requestAnimationFrame(this.reset.bind(this));
        }


        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        //this.closeMenuDisclosure();
        this.closeSearchModal();
    }

    reveal() {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
        this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
    }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel"] && !Shopify.designMode) return;
  try {
    
let imageSwipers = [];
const $imageSwipers = document.querySelectorAll('.image-carousel:not(.swiper-initialized)');
if($imageSwipers && $imageSwipers.length > 0) {
  $imageSwipers.forEach(($imageSwiper) => {
    const sectionId = $imageSwiper.dataset.sectionId;
    const mobileSlides = parseInt($imageSwiper.dataset.slidesMobile);
    const desktopSlides = parseInt($imageSwiper.dataset.slidesDesktop);
    const imageSwiper = new Swiper($imageSwiper, {
      loop: true,
      slidesPerView: mobileSlides,
      breakpoints: {
        768: {
          slidesPerView: desktopSlides,
          spaceBetween: 10,
        }
      },
      navigation: {
        nextEl: '.button-next-'+sectionId,
        prevEl: '.button-prev-'+sectionId,
      },
    });
    imageSwipers.push(imageSwiper);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-assets"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              document.body.dispatchEvent(new Event('productRecommendationsLoaded'));
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  const productsTabBtns = document.querySelectorAll('.rich-text__product-tabs button');
  productsTabBtns.forEach((productsTabBtn) => {
    productsTabBtn.addEventListener('click', function() {
      const siblings = this.closest('.rich-text__product-tabs--wrapper').querySelectorAll('button');
      siblings.forEach((btn) => {
        btn.classList.remove('active')
      });
      this.classList.add('active');

      const pannels = this.closest('.rich-text__product-tabs').querySelectorAll('.rich-text__product-tab');
      pannels.forEach((panel) => {
        panel.classList.add('hidden');
      });
      const id = this.dataset.id;
      const focusPannel = document.getElementById(id);
      if(focusPannel) focusPannel.classList.remove('hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanctuary-organizations"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function() {
    const organizationsSwiper = new Swiper('.sanctuary-organizations__slider', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      centeredSlides: true,
      slidesPerView: 7,
      spaceBetween: 10,
      breakpoints: {
        320: {
          slidesPerView: 3,
          spaceBetween: 10
        },
        640: {
          slidesPerView: 4,
          spaceBetween: 10
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 10
        },
        992: {
          slidesPerView: 7,
          spaceBetween: 10
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
let testimonialSwipers = [];
const $testimonialSwipers = document.querySelectorAll('.testimonials-carousel:not(.swiper-initialized)');
if($testimonialSwipers && $testimonialSwipers.length > 0) {
  $testimonialSwipers.forEach(($testimonialSwiper) => {
    const sectionId = $testimonialSwiper.dataset.sectionId;
    const testimonialSwiper = new Swiper($testimonialSwiper, {
      loop: true,
      navigation: {
        nextEl: '.button-next-'+sectionId,
        prevEl: '.button-prev-'+sectionId,
      },
    });
    testimonialSwipers.push(testimonialSwiper);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-resources"] && !Shopify.designMode) return;
  try {
    
  const videoTabBtns = document.querySelectorAll('.video-resources button');
  videoTabBtns.forEach((videoTabBtn) => {
    videoTabBtn.addEventListener('click', function() {
      const siblings = this.closest('.video-resources-tabs--wrapper').querySelectorAll('button');
      siblings.forEach((btn) => {
        btn.classList.remove('active')
      });
      this.classList.add('active');

      const pannels = this.closest('.video-resources').querySelectorAll('.video-resources--tab');
      pannels.forEach((panel) => {
        panel.classList.add('hidden');
      });
      const id = this.dataset.id;
      const focusPannel = document.getElementById(id);
      if(focusPannel) focusPannel.classList.remove('hidden');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
